import {
  selectCurrentInspectorState,
  selectCurrentTemplate,
  selectTemplateHasChanges,
} from "@/store/templateEditor/templateEditorSelectors";
import { useSelector } from "react-redux";
import { TextInspector } from "./TextInspector";
import { useTranslation } from "react-i18next";
import { TemplateSettingsInpector } from "./TemplateSettingsInpector";
import { ImageInspector } from "./ImageInspector";
import { MediaLibraryInspector } from "./MediaLibraryInspector";
import { SaveIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { CanvasData, FabricData } from "@/components/canvas/types/canvasTypes";
import { LoadingSmall } from "@/components/LoadingSmall";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { ShapeInspector } from "./ShapeInspector";

const NotImplementedInspector = () => null;

const Inspectors: Record<ReturnType<typeof selectCurrentInspectorState>, React.FC> = {
  text: TextInspector,
  image: ImageInspector,
  projectSettings: TemplateSettingsInpector,
  "media-library": MediaLibraryInspector,
  group: NotImplementedInspector,
  shapes: ShapeInspector,
};

interface Props {
  onClickSave: (data: FabricData) => void;
  saving: boolean;
}

export const Inspector: React.FC<Props> = ({ onClickSave, saving }) => {
  const { t } = useTranslation();
  const currentInspectorState = useSelector(selectCurrentInspectorState);
  const InspectorComp = Inspectors[currentInspectorState];
  const currentTemplate = useSelector(selectCurrentTemplate);
  const latestCanvasData = currentTemplate?.canvas_data;
  const hasChanges = useSelector(selectTemplateHasChanges);

  return (
    <div>
      <div className="p-2 border-b h-[48px] flex items-center justify-between">
        <div>{t("template.inspector.title")}</div>
        <div>
          <Button
            size="sm"
            onClick={() => {
              onClickSave(latestCanvasData as CanvasData);
            }}
            disabled={!hasChanges || saving}
          >
            {saving ? <LoadingSmall /> : <SaveIcon />} {t("common.save")}
          </Button>
        </div>
      </div>
      <div className="pr-2">
        <InspectorComp />
        {currentInspectorState === "text" && (
          <div className="p-2 pl-0">
            <Alert className="m-2" variant="info">
              <AlertTitle>{t("common.info")}</AlertTitle>
              <AlertDescription>
                {t("template.inspector.help1")}
                <br />
                <br />
                {t("template.inspector.help2")}
              </AlertDescription>
            </Alert>
          </div>
        )}
      </div>
    </div>
  );
};
